module.exports = __webpack_public_path__ + "media/assets/images/landing/жилье-e217bf284ffedeedabe16fe8a34a8f19.png";